import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "@env/environment";
import {catchError, retry} from "rxjs/operators";
import {BehaviorSubject, Observable, of} from "rxjs";
import {ConstantsService} from "@app/services/constants/constants.service";

@Injectable({
    providedIn: 'root'
})
export class BoardsService {
    apiURL = environment.apiURL;
    newBoardBS = new BehaviorSubject<boolean>(false);

    constructor(private http: HttpClient,
                private constants: ConstantsService) {
    }

    handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            return of(result as T);
        };
    }

    getBoards(projectId) {
        let params = new HttpParams().set('project_id', projectId);

        return this.http.get(this.apiURL + '/boards/getBoards', {params: params})
            .pipe(retry(1),
                catchError(this.handleError('getBoards')))
    }

    // dodavanje nove kolone za odredjeni board
    addNewColumnToBoard(boardId, columnName) {
        let params = new HttpParams().set('board_id', boardId).set('new_column', columnName)

        return this.http.post(this.apiURL + '/boards/addNewColumnToBoard', params)
            .pipe(retry(1),
                catchError(this.handleError('addNewColumnToBoard')))
    }

    getBoard(id) {
        let params = new HttpParams().set('id', id);
        return this.http.get(this.apiURL + '/boards/getBoard', {params: params})
            .pipe(retry(1),
                catchError(this.handleError('getBoard')));
    }

    // funkcija za podesavanje statusa kolona
    onColumnStatusesChange(data, boardId) {
        let params = new HttpParams().set('board_id', boardId).set('data', JSON.stringify(data));
        return this.http.post(this.apiURL + '/boards/statusesSettings', params)
            .pipe(retry(1),
                catchError(this.handleError('getBoard')));
    }

    addBoard(boardName, type: string, projectId?: string, hashes?: []) {
        let params = new HttpParams()
            .set('projectId', projectId)
            .set('name', boardName)
            .set('type', type)
            .set('hashes', JSON.stringify(hashes))
            .set('user_id', this.constants.creator_id);

        return this.http.post(this.apiURL + '/boards/createBoard', params)
            .pipe(retry(1),
                catchError(this.handleError('addBoard')))
    }


    // funkcija za premjestanje taskova u drugu kolonu
    transferTaskToColumn(taskId, newColumId, boardId, sort) {

        let params = new HttpParams()
            .set('task_id', taskId)
            .set('column_id', newColumId)
            .set('sort', sort)
            .set('board_id', boardId);
        return this.http.post(this.apiURL + '/boards/transferTaskToColumn', params).pipe(
            retry(1),
            catchError(this.handleError('transferTaskToColumn')));

    }

    getUserBoards() {
        let params = new HttpParams().set('user_id', this.constants.creator_id);
        return this.http.get(this.apiURL + '/boards/getUserBoards', {params: params})
            .pipe(retry(1),
                catchError(this.handleError('getUserBoards')));
    }

    changeColumnOrderNumber(boardId, columns) {
        let params = new HttpParams().set('board_id', boardId)
            .set('columns', JSON.stringify(columns));

        return this.http.post(this.apiURL + '/boards/changeOrderNumber', params).pipe(
            retry(1),
            catchError(this.handleError('changeColumnOrderNumber')));
    }

    colorChange(boardId: string, columnId: string, color: string) {
        let params = new HttpParams().set('board_id', boardId)
            .set('boardId', boardId)
            .set('columnId', columnId)
            .set('color', color);
        return this.http.post(this.apiURL + '/boards/changeColumnColor', params).pipe(
            retry(1),
            catchError(this.handleError('colorChange')));
    }

    completeSprints(projectId) {
        let params = new HttpParams().set('project_id', projectId);
        return this.http.post(this.apiURL + '/boards/completeSprints', params).pipe(
            retry(1),
            catchError(this.handleError('completeSprints')));

    }


}
